import React from 'react';
import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { useMorningBriefing } from '../../hooks/useMorningBriefing';
import BriefingCard from './BriefingCard';

export default function MorningBriefing({ tasks = [], googleEvents = [], icalEvents = [], outlookEvents = [] }) {
  const { currentUser } = useCurrentUser();

  const { briefing, loading, resendEmail, shouldShow, mode, briefingTime } =
    useMorningBriefing({ tasks, googleEvents, icalEvents, outlookEvents });

  if (!shouldShow) return null;

  const emailConnected = !!(
    currentUser?.emailConnections?.gmail?.connected ||
    currentUser?.emailConnections?.outlook?.connected ||
    currentUser?.emailConnections?.imap?.connected
  );

  return (
    <BriefingCard
      briefing={briefing}
      loading={loading}
      onResendEmail={resendEmail}
      emailConnected={emailConnected}
      mode={mode}
      briefingTime={briefingTime}
    />
  );
}
